const normalize = (value = '') => value.trim().toLocaleLowerCase();

const dateOnly = (value = '') => value.split('T')[0];

export const filterFieldVisits = (visits, filters) => visits.filter((visit) => {
  const visitDate = dateOnly(visit.visit_date);
  const matchesFrom = !filters.dateFrom || (visitDate && visitDate >= filters.dateFrom);
  const matchesTo = !filters.dateTo || (visitDate && visitDate <= filters.dateTo);
  const matchesLocation = !filters.location
    || normalize(visit.geography_market) === normalize(filters.location);
  const visitBuyers = visit.buyer_names || [visit.buyer_name].filter(Boolean);
  const matchesBuyer = !filters.buyer
    || visitBuyers.some((buyerName) => normalize(buyerName) === normalize(filters.buyer));
  return matchesFrom && matchesTo && matchesLocation && matchesBuyer;
});

export const uniqueVisitValues = (visits, field) => Array.from(new Set(
  visits.flatMap((visit) => {
    const value = visit[field];
    if (Array.isArray(value)) return value.map((item) => item?.trim()).filter(Boolean);
    return value?.trim() ? [value.trim()] : [];
  }),
)).sort((left, right) => left.localeCompare(right));